import { ReactNode } from 'react';

const SPKTimeline = ({ childrens }: { childrens: ReactNode[] | undefined }) => {
  if (!childrens) return null;

  return (
    <div className="flex flex-col items-start">
      {childrens.map((singleChild, index) => {
        return (
          <div
            key={`${Math.random()}`}
            className="flex flex-row text-sm relative items-stretch"
          >
            <div
              className={`${
                index === childrens.length - 1 ? 'border-none' : 'border-r-2'
              } border-neutral-300 flex items-center justify-center h-full mr-4 ml-2 mt-1`}
            >
              <span className="rounded-full border-neutral-300 border-2 w-5 h-5 block bg-white absolute top-0" />
            </div>
            <div className="pb-8">{singleChild}</div>
          </div>
        );
      })}
    </div>
  );
};

export default SPKTimeline;
